export default {
    /*
     * index() lista los movimientos de un pasajero
     */
    index(params) {
    return Vue.http.get('passenger/movements', {params}).then(response => response.data)
  }
}
